import classNames from 'classnames';
import type { CSSProperties, JSX, ReactNode } from 'react';

import './Paragraph.less';

export const Paragraph = ({ children, className, style }: { children: ReactNode; className?: string; style?: CSSProperties }): JSX.Element => {
  return (
    <div className={classNames('p', className)} style={style}>
      {children}
    </div>
  );
};
